(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    const container = document.querySelector('.blog-list-inner');
    const items = document.querySelectorAll('.blog-list-item');

    function getGridColumnsAndSpacing() {
        const screenWidth = window.innerWidth;

        if (screenWidth <= 767) {
            return { columns: 1, spacing: parseInt(container.getAttribute('data-grid-space')) || 20 };
        } else if (screenWidth >= 768 && screenWidth <= 1023) {
            return { columns: 2, spacing: parseInt(container.getAttribute('data-grid-space')) || 20 };
        } else if (screenWidth >= 1024 && screenWidth <= 1199) {
            return { columns: 3, spacing: parseInt(container.getAttribute('data-grid-space')) || 20 };
        } else {
            return { columns: parseInt(container.getAttribute('data-grid-column')) || 5, spacing: parseInt(container.getAttribute('data-grid-space')) || 20 };
        }
    }

    function applyMasonryLayout() {
        const { columns, spacing } = getGridColumnsAndSpacing();

        // Set CSS variables for columns and spacing
        container.style.setProperty('--columns', columns);
        container.style.setProperty('--spacing', `${spacing}px`);

        const columnHeights = Array(columns).fill(0); // Store the height of each column

        items.forEach((item, i) => {
            // Reset styles to avoid interference
            item.style.position = 'absolute';
            item.style.top = '0px';
            item.style.left = '0px';
            item.style.width = `calc((100% / ${columns}) - ${spacing}px)`;

            // Find the shortest column
            const shortestColumn = columnHeights.indexOf(Math.min(...columnHeights));
            
            // Position the item
            item.style.top = `${columnHeights[shortestColumn]}px`;
            item.style.left = `calc(${(100 / columns) * shortestColumn}% + 0px)`;

            // Update the height of the column
            columnHeights[shortestColumn] += item.offsetHeight + spacing;
        });

        // Adjust the height of the container to fit all items
        container.style.height = `${Math.max(...columnHeights)}px`;

        // Make the container visible after layout is done
        container.style.visibility = 'visible';
    }

    // Initial layout application
    applyMasonryLayout();

    // Reapply layout on window resize
    window.addEventListener('resize', applyMasonryLayout);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    const headings = document.querySelectorAll('.footer-block__heading');

    headings.forEach(heading => {
        heading.addEventListener('click', function () {
            const detailsContent = this.nextElementSibling;

            if (detailsContent && detailsContent.classList.contains('footer-block__details-content')) {
                detailsContent.classList.toggle('expanded');
                this.classList.toggle('active');
            }
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
   document.querySelectorAll('.grid-layout-item').forEach(button => {
    button.addEventListener('click', () => {
      // Toggle active class
      document.querySelectorAll('.grid-layout-item').forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');
  
      // Add or remove data-grid-two on #product-grid
      const productGrid = document.querySelector('#product-grid');
      if (button.hasAttribute('data-grid-layout-single')) {
        //productGrid.classList.add('data-grid-two');
        document.body.classList.add('data-grid-two');
      } else {
        //productGrid.classList.remove('data-grid-two');
        document.body.classList.remove('data-grid-two');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["master-grid"] && !Shopify.designMode) return;
  try {
    
// Check if the script has already been executed
if (!window.hotspotScriptLoaded) {
    document.addEventListener('DOMContentLoaded', function () {
        const hotspots = document.querySelectorAll('.hotspot-item');

        hotspots.forEach(hotspot => {
            const trigger = hotspot.querySelector('.hotspot-item-trigger');
            const popup = hotspot.querySelector('.hotspot-item-product');
            const closeButton = popup.querySelector('.hotspot-item-product-close'); 

            let isHovering = false;
            let timeoutId;

            const addClass = () => {
                hotspot.classList.add('active');
                isHovering = true;
                clearTimeout(timeoutId);
            };

            const removeClass = () => {
                isHovering = false;
                timeoutId = setTimeout(() => {
                    if (!isHovering) {
                        hotspot.classList.remove('active');
                    }
                }, 100);
            };

            const checkHoverState = (event) => {
                const relatedTarget = event.relatedTarget;
                if (!hotspot.contains(relatedTarget)) {
                    removeClass();
                } else {
                    clearTimeout(timeoutId);
                }
            };

            trigger.addEventListener('mouseenter', addClass);
            trigger.addEventListener('mouseleave', checkHoverState);

            popup.addEventListener('mouseenter', addClass);
            popup.addEventListener('mouseleave', checkHoverState);

            // Add event listener for the close button
            if (closeButton) {
                closeButton.addEventListener('click', () => {
                    hotspot.classList.remove('active');
                    clearTimeout(timeoutId);
                    isHovering = false;
                });
            }

        });
    });

    // Set the flag to indicate the script has been executed
    window.hotspotScriptLoaded = true;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["padani-stories"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  function initInfiniteScroll() {
    console.log("Initializing infinite scroll");
    const storiesGrid = document.querySelector(".padani-stories__grid");
    const storiesItems = Array.from(document.querySelectorAll(".padani-stories__item"));
    const loaderContainer = document.querySelector("#padani-stories-loader");
    const loader = document.querySelector(".padani-stories__loader");
    
    if (!storiesGrid || !loaderContainer || storiesItems.length === 0) {
      console.log("Missing required elements");
      return;
    }
    
    // Configuration
    const itemsPerPage = 6;
    let currentlyShown = itemsPerPage;
    let isLoading = false;
    let totalItems = storiesItems.length;
    
    console.log(`Total items: ${totalItems}, Items per page: ${itemsPerPage}`);
    
    // Make sure only the first 6 items are visible initially
    storiesItems.forEach((item, index) => {
      if (index >= itemsPerPage) {
        item.style.display = 'none';
      } else {
        item.style.display = '';
      }
    });
    
    function applyMasonry() {
      const visibleItems = storiesItems.filter(item => item.style.display !== 'none');
      
      if (visibleItems.length === 0) return;
      
      let columnCount = getColumnCount();
      let columnHeights = Array(columnCount).fill(0);
      let columnGap = 60; // Horizontal gap
      let rowGap = 80; // Vertical gap
      
      let totalGapWidth = (columnCount - 1) * columnGap;
      let columnWidth = (storiesGrid.clientWidth - totalGapWidth) / columnCount;
      
      storiesGrid.style.position = "relative";
      
      // Check if the container has RTL direction
      let isRTL = document.documentElement.dir === "rtl" || storiesGrid.closest("[dir='rtl']");
      
      visibleItems.forEach(item => {
        let minColumnIndex = columnHeights.indexOf(Math.min(...columnHeights));
        
        item.style.position = "absolute";
        item.style.top = `${columnHeights[minColumnIndex]}px`;
        item.style.width = `${columnWidth}px`; 
        
        if (isRTL) {
          // Position items from right to left
          item.style.right = `${(minColumnIndex * (columnWidth + columnGap))}px`;
        } else {
          // Default LTR positioning
          item.style.left = `${(minColumnIndex * (columnWidth + columnGap))}px`;
        }
        
        columnHeights[minColumnIndex] += item.offsetHeight + rowGap; // Apply vertical spacing
      });
      
      storiesGrid.style.height = `${Math.max(...columnHeights)}px`; // Set the correct height
      
      // Hide/show loader based on whether there are more items to load
      if (currentlyShown >= totalItems) {
        loaderContainer.style.display = 'none';
        console.log("All items displayed, hiding loader");
      } else {
        loaderContainer.style.display = 'flex';
        console.log("More items to load, showing loader");
      }
    }
    
    function getColumnCount() {
      const screenWidth = window.innerWidth;
      if (screenWidth >= 1024) return 3; // 3 columns for large screens
      if (screenWidth >= 750) return 2;  // 2 columns for tablets
      return 1;                          // 1 column for mobile
    }
    
    function loadMoreItems() {
      if (isLoading || currentlyShown >= totalItems) {
        console.log("Already loading or all items shown");
        return;
      }
      
      console.log("Starting to load more items");
      isLoading = true;
      
      // Simulate loading for 1 second
      setTimeout(() => {
        console.log("Loading next batch of items");
        // Determine how many more items to show
        const itemsToShow = Math.min(itemsPerPage, totalItems - currentlyShown);
        
        // Show the next batch of items
        for (let i = 0; i < itemsToShow; i++) {
          const index = currentlyShown + i;
          if (index < totalItems) {
            storiesItems[index].style.display = '';
          }
        }
        
        currentlyShown += itemsToShow;
        console.log(`Now showing ${currentlyShown} of ${totalItems} items`);
        
        // Re-apply masonry layout with a slight delay to ensure newly displayed items have rendered
        setTimeout(() => {
          applyMasonry();
          isLoading = false;
          
          // If there are no more items to load, stop observing
          if (currentlyShown >= totalItems) {
            console.log("All items shown, stopping observation");
            observer.unobserve(loaderContainer);
          }
        }, 100);
      }, 1500); // 1.5 seconds of visible loading
    }
    
    // Wait for all visible images to load before applying initial masonry layout
    function waitForImagesAndApplyLayout() {
      console.log("Waiting for images to load");
      const visibleItems = storiesItems.filter((item, index) => index < itemsPerPage);
      const visibleImages = visibleItems.map(item => item.querySelector('img')).filter(Boolean);
      
      if (visibleImages.length === 0) {
        applyMasonry();
        return;
      }
      
      let loadedCount = 0;
      const onImageLoad = () => {
        loadedCount++;
        if (loadedCount === visibleImages.length) {
          console.log("All visible images loaded, applying masonry");
          // Add a small delay to ensure browser has updated all dimensions
          setTimeout(applyMasonry, 50);
        }
      };
      
      visibleImages.forEach(img => {
        if (img.complete) {
          onImageLoad();
        } else {
          img.addEventListener('load', onImageLoad);
          img.addEventListener('error', onImageLoad); // Count errors as loaded to prevent hanging
        }
      });
    }
    
    // Initialize masonry layout after images load
    waitForImagesAndApplyLayout();
    
    // Set up intersection observer only if there are more items to show
    if (totalItems > itemsPerPage) {
      console.log("Setting up intersection observer");
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          console.log(`Loader intersection: ${entry.isIntersecting}`);
          if (entry.isIntersecting && !isLoading) {
            loadMoreItems();
          }
        });
      }, {
        rootMargin: '200px', // Load earlier, before fully scrolling to the loader
        threshold: 0.1 // Trigger when at least 10% of the loader is visible
      });
      
      observer.observe(loaderContainer);
    } else {
      loaderContainer.style.display = 'none';
    }
    
    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(applyMasonry, 100); // Debounce resize events
    });
  }
  
  // Start the infinite scroll functionality
  initInfiniteScroll();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stores"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
        const radioButtons = document.querySelectorAll('input[name="stores"]');
        const searchInput = document.querySelector('input[data-store-search-input]');
        const storeItems = document.querySelectorAll('.store-item');

        const filterStores = () => {
            const selectedCountry = document.querySelector('input[name="stores"]:checked').id;
            const searchTerm = searchInput.value.trim().toLowerCase();

            storeItems.forEach(item => {
                const itemCountry = item.getAttribute('data-search-country').toLowerCase();
                const itemAddress = item.getAttribute('data-search-address').toLowerCase();
                const itemStoreName = item.getAttribute('data-store-search').toLowerCase();

                const countryMatch = selectedCountry === 'all' || itemCountry.includes(selectedCountry.toLowerCase());
                const addressMatch = itemAddress.includes(searchTerm);
                const storeNameMatch = itemStoreName.includes(searchTerm);

                if (countryMatch && (addressMatch || storeNameMatch)) {
                    item.style.display = 'block';
                } else {
                    item.style.display = 'none';
                }
            });
        };

        radioButtons.forEach(radio => {
            radio.addEventListener('change', filterStores);
        });

        searchInput.addEventListener('input', filterStores);

        // Initial filtering on page load
        filterStores();
    });

  } catch(e) { console.error(e); }
})();
})();
